import { adminSessionSchema, type AdminSession } from '@kon/shared';

/**
 * Admin session persistence. The signed bearer token from /auth/login is kept
 * in localStorage; the API client attaches it to every request and fires
 * UNAUTHORIZED_EVENT when the server rejects it, which logs the UI out.
 */

const STORAGE_KEY = 'kon.admin.session';

/** Dispatched (on window) when the API returns 401 for an authed request. */
export const UNAUTHORIZED_EVENT = 'kon-admin-unauthorized';

export function readSession(): AdminSession | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = adminSessionSchema.safeParse(JSON.parse(raw));
    if (!parsed.success) {
      clearSession();
      return null;
    }
    if (Date.parse(parsed.data.expiresAt) <= Date.now()) {
      clearSession();
      return null;
    }
    return parsed.data;
  } catch {
    return null;
  }
}

export function writeSession(session: AdminSession): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearSession(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}

export function notifyUnauthorized(): void {
  clearSession();
  window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
}
